import { HomeScreen } from '@strata/react-page-templates';
import { useParams } from 'react-router';

import { Application } from 'pages/homeScreenMessaging/HomeScreenHelpers';
import { useGet } from 'services/Http';

/** Home Screen content copied from the respective application's code */
const AppHomeScreenContent = {
    [Application.AGORA]: {
        illustration: HomeScreen.Illustration.AGORA,
        buttonLabel: 'View Referrals',
        welcomeMessagePartOne:
            "With Free Market Health's Agora Monitoring Application, you can now view a referral's journey in real time. Dynamically aligned with our backend services, Agora is revolutionizing the visibility process as we know it.",
        welcomeMessagePartTwo:
            "At the center of it all is our data, which needs visibility. Agora is part of Free Market Health's transparent process that aligns the priorities of team members, for the health of all.",
    },
    [Application.APERTURE]: {
        illustration: HomeScreen.Illustration.PAYERS,
        buttonLabel: 'View Products',
        welcomeMessagePartOne:
            'FMH for Payers provides health plan partners with unprecedented visibility into their specialty drug referrals and specialty pharmacy performance.',
    },
    [Application.COMPASS]: {
        illustration: HomeScreen.Illustration.COMPASS,
        buttonLabel: 'View Requests',
        welcomeMessagePartOne:
            "With Free Market Health's Compass application, you have the ability to guide and improve a Payer's experience by managing member inquiries and fulfilling change management requests.",
    },
    [Application.LIGHTHOUSE]: {
        illustration: HomeScreen.Illustration.LIGHTHOUSE,
        buttonLabel: 'View Intake Form',
        welcomeMessagePartOne:
            "Free Market Health's Lighthouse application enables a single access point for Prescribers and Pharmacies to facilitate Prior Auth requests. The application seamlessly guides FMH users through each step of the Prior Auth process, reducing the complexity of navigating from initiation to submission to a Payer. Lighthouse enhances the FMH ecosystem by further complimenting the value created by the care-driven marketplace, delivering a simplified experience for payers, providers, and members.",
    },
    [Application.MKT]: {
        illustration: HomeScreen.Illustration.PHARMACIES,
        buttonLabel: 'View Live Referrals',
        welcomeMessagePartOne:
            'Our care-driven marketplace platform provides fair access to payer-authorized specialty drug referrals. These live referrals identify specific patient care needs so you can easily access and compete for the referrals best suited to your care model.',
    },
    [Application.HUBBLE]: {
        illustration: HomeScreen.Illustration.HUBBLE,
        buttonLabel: 'View Claims',
        welcomeMessagePartOne:
            "With Free Market Health's Hubble Application, you have visibility into submitted claims and their status to ensure they have been successfully received by payers. The automated process tracks and alerts on each claim adjudication step.",
    },
    [Application.RTA]: {
        illustration: HomeScreen.Illustration.HEART,
        buttonLabel: 'Enter Referral',
        welcomeMessagePartOne:
            'With Real Time Auth (RTA), you can obtain specialty drug authorizations quickly. Dynamically aligned to health plan drug policies, RTA streamlines the prior authorization and referral process to get your patients started on therapy sooner.',
    },
};

export const HomeScreenPreview = () => {
    const { application } = useParams();
    const messages = useGet(`/announcement/admin/home_screen/${application}`);
    return (
        <HomeScreen
            illustration={AppHomeScreenContent[application]?.illustration}
            button={{ label: AppHomeScreenContent[application]?.buttonLabel, path: '' }}
            welcomeMessagePartOne={AppHomeScreenContent[application]?.welcomeMessagePartOne}
            welcomeMessagePartTwo={AppHomeScreenContent[application]?.welcomeMessagePartTwo}
            messages={messages}
        />
    );
};
